import { useEffect, useState } from 'react';

const detectIOSSafari = () => {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  // Exclude Chrome/Firefox/Opera on iOS (they use CriOS / FxiOS / OPiOS)
  const isSafari = /^((?!CriOS|FxiOS|OPiOS|EdgiOS).)*Safari/i.test(ua);
  const alreadyInstalled = window.navigator.standalone === true;
  return isIOS && isSafari && !alreadyInstalled;
};

export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Android / Chrome / Edge: native install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // iOS Safari: no browser API, needs manual Add to Home Screen
    if (detectIOSSafari()) setIsIOS(true);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setIsInstallable(false);
  };

  return { isInstallable, isIOS, promptInstall };
}
